export const getTextParts = (text: string, highlightedPhrases: string[]) => {
  if (highlightedPhrases.length === 0) return [text];
  const regex = new RegExp(
    `(${highlightedPhrases.map(p => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
    'gi',
  );
  const textParts = text.split(regex);

  return textParts;
};

export const isHighlightedPhrase = (part: string, highlightedPhrases: string[]) => {
  return highlightedPhrases.includes(part);
};
